import { render, staticRenderFns } from "./OSSFileList.vue?vue&type=template&id=f83b1754&scoped=true&"
import script from "./OSSFileList.vue?vue&type=script&lang=js&"
export * from "./OSSFileList.vue?vue&type=script&lang=js&"
import style0 from "./OSSFileList.vue?vue&type=style&index=0&id=f83b1754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83b1754",
  null
  
)

export default component.exports